import {Component, OnInit} from '@angular/core';
import {Page} from '../../../../global/util/enum/Page';
import {Partner} from '../../../model/Partner';
import {Enterprise} from '../../../model/Enterprise';
import {Constant} from '../../../../global/util/Constant';
import {NgbCalendar, NgbDate, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {NgbDateStructUtil} from '../../../../global/util/NgbDateStructUtil';
import {AuthService} from '../../../service/auth/auth.service';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {EnterpriseStorageDetailService} from '../../../service/enterprise-storage-detail.service';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Dialog} from '../../../../global/util/Dialog';
import {InformType} from '../../../../global/util/enum/InformType';
import {TranslateService} from '@ngx-translate/core';
import {ConvertBytes} from '../../../../global/util/ConvertBytes';
import {Pagination} from '../../../../global/util/Pagination';

@Component({
  selector: 'app-report-storage',
  templateUrl: './report-storage.component.html',
  styleUrls: ['./report-storage.component.css']
})
export class ReportStorageComponent implements OnInit {
  title = '';
  partners: Partner[] = [];
  enterprises: Enterprise[] = [];
  enterpriseSelected: any;
  partnerSelected: any;
  ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  ROLE_PARTNER = Constant.ROLE_PARTNER;
  ROLE_ADMIN = Constant.ROLE_ADMIN;
  public fromDate: NgbDate;
  public toDate: NgbDate;
  public enterpriseStorageDetails: any[] = [];
  public page: any = {};
  public links: any = {};
  loading: boolean;
  enumPage = Page;
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(private calendar: NgbCalendar,
              public formatter: NgbDateParserFormatter,
              private authenticationService: AuthService,
              private storageService: EnterpriseStorageDetailService,
              private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.loadDefaultData();
    this.reloadStorage();
  }

  hasRole(name: string): boolean {
    return this.authenticationService.hasRole(name);
  }

  reloadStorage() {
    this.loadStorage(Page.First);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }


  clearSearch() {
    localStorage.removeItem('selectedControls');
    this.loadDefaultData();
  }

  downloadReportOf() {
    this.loading = true;
    let partnerId;
    let enterpriseId;
    let url;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      partnerId = this.partnerSelected.id;
      enterpriseId = this.enterpriseSelected.id;
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      partnerId = LocalStorage.getPartnerId();
      enterpriseId = this.enterpriseSelected.id;
    } else {
      partnerId = LocalStorage.getPartnerId();
      enterpriseId = LocalStorage.getEnterpriseId();
    }
    url = Constant.ROOT_API_V1.concat('/storage/used/download?',
      'partnerId=', String(partnerId),
      '&enterpriseId=', String(enterpriseId),
      '&startDate=', NgbDateStructUtil.toString(this.fromDate),
      '&endDate=', NgbDateStructUtil.toString(this.toDate));
    this.storageService.getReportOf(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = this.translate.instant('TITLE.REPORT-STORAGE-CONSOLIDATED');
      control.click();
      this.loading = false;
    }, error => {
      this.loading = false;
      this.processError(this.title, error.message);
    });
  }

  loadStorage(page: Page) {
    let url;
    let partnerId;
    let enterpriseId;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      partnerId = this.partnerSelected.id;
      enterpriseId = this.enterpriseSelected.id;
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      partnerId = LocalStorage.getPartnerId();
      enterpriseId = this.enterpriseSelected.id;
    } else {
      partnerId = LocalStorage.getPartnerId();
      enterpriseId = LocalStorage.getEnterpriseId();
    }
    switch (page) {
      case Page.First:
        url = Constant.ROOT_API_V1.concat('/partner/')
          .concat(String(partnerId))
          .concat('/enterprises/')
          .concat(String(enterpriseId))
          .concat('/storage')
          .concat('?startDate=', String(NgbDateStructUtil.toString(this.fromDate)),
            '&endDate=', String(NgbDateStructUtil.toString(this.toDate)),
            '&size=' + this.pageNumber + '&sort=id,desc');
        break;
      case Page.Previous:
        url = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        url = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        url = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        url = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.getStorageDetails(url);
  }

  search() {
    this.reloadStorage();
  }

  onDateSelectionFrom(date: NgbDate) {
    if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.fromDate = date;
    }
  }

  onDateSelectionTo(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else {
      this.toDate = date;
    }
  }

  private getStorageDetails(url) {
    this.loading = true;
    this.storageService.getAllBy(url).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.enterpriseStorageDetails = next._embedded.enterprisestoragedetail;
      } else {
        this.enterpriseStorageDetails = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.loading = false;
      this.processError(this.translate.instant('TITLE.REPORT-STORAGE-CONSOLIDATED'), error);
    });
  }

  processError(title: string, error: any) {
    const status = error.status;
    this.title = this.translate.instant('TITLE.REPORT-STORAGE-CONSOLIDATED');
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  getStorageSize(size) {
    return ConvertBytes.format(size, 2);
  }

  private loadDefaultData() {
    const controls = LocalStorage.getSelectedControls();
    this.partners = LocalStorage.getPartnersExtra();
    this.enterprises = LocalStorage.getEnterprisesExtra();
    this.partnerSelected = controls ? this.partners.find(value => value.id === controls.partnerId) : this.partners[Constant.ZERO_INDEX];
    this.enterpriseSelected = controls ? this.enterprises.find(value => value.id === controls.partnerId) : this.enterprises[Constant.ZERO_INDEX];
  }

  clean() {
    this.fromDate = null;
    this.toDate = null;
  }
}
